import { MenuItem, TextField } from "@mui/material";
import { useGetPharmaciesQuery } from "src/api/services/pharmacyApi";
import { FilterProps } from "src/api/types";

const PharmacyFilter = ({ filter, onChange, placeholder }: FilterProps) => {
  const { data = [] } = useGetPharmaciesQuery();

  return (
    <TextField
      label={placeholder}
      select
      sx={{ width: 180 }}
      size="small"
      value={filter}
      onChange={onChange}
    >
      <MenuItem value={""}>{"None"}</MenuItem>
      {data.map((pharmacy) => (
        <MenuItem key={pharmacy.id} value={pharmacy.name}>
          {pharmacy.name}
        </MenuItem>
      ))}
      <MenuItem value={"Local pharmacy"}>Local pharmacy</MenuItem>
    </TextField>
  );
};

export default PharmacyFilter;
